import { call, put, takeLatest } from "redux-saga/effects";
import { postExamGroup } from "../../../services/examGroup";
import {
  createGroupStart,
  createGroupSuccess,
  createGroupFailure,
} from "../reducer";
import { successNotifier } from "../../../utils/helpers";
import { networkErrorHandler } from "../../../utils/errorHandlers";

export function* createExamGroup({ payload }) {
  const { data, callback } = payload;

  const response = yield call(postExamGroup, data);
  const { success, raw, message, statusCode } = response;

  if (success) {
    yield put(createGroupSuccess());
    successNotifier("Exam group created successfully");
    if (callback) {
      callback();
    }
  } else {
    yield put(createGroupFailure());
    networkErrorHandler(statusCode, message || raw.error);
  }
}

export default function* onCreateGroup() {
  yield takeLatest(createGroupStart.type, createExamGroup);
}
